<template>
  <div>
    <!-- Informations -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold p-0 pl-2 m-0">
          {{ $t('lineidpage.fieldset.information') }}
        </p>
      </template>
      <div class="card_details ">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.requestId') }} : <span class="font-bold">{{ lineId.requestId }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.requestDate') }} : <span class="font-bold">{{ lineId.requestDate }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.mainVenue') }} : <span class="font-bold">{{ $i18n.locale === 'fr' ? lineId.mainVenue.frenchWording : lineId.mainVenue.englishWording }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.otherVenues') }} : <span class="font-bold">{{ lineId.otherVenues }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.stakeholderId') }} : <span class="font-bold">{{ lineId.stakeholderId }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.licencePeriod') }} : <span class="font-bold">{{ $t(`entity.lineId.licencePeriods.${lineId.licencePeriod}`) }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.startDate') }} : <span class="font-bold">{{ lineId.startDate }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.endDate') }} : <span class="font-bold">{{ lineId.endDate }}</span>
            </p>
            <p class="col-12">
              {{ $t('entity.lineId.remarks') }} : <span class="font-bold">{{ lineId.remarks }}</span>
            </p>
          </div>
        </div>
      </div>
    </Panel>

    <!-- Spécifications de la fréquence -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold p-0 pl-2 m-0">
          {{ $t('lineidpage.fieldset.frequency') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.usageType') }} : <span class="font-bold">{{ $t(`entity.lineId.usageTypes.${lineId.usageType}`) }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.duplex') }} : <span class="font-bold">{{ $t(`entity.lineId.duplexOptions.${lineId.duplex.toString()}`) }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.channelBandwidth') }} : <span class="font-bold">{{ lineId.channelBandwidth }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.tuningStep') }} : <span class="font-bold">{{ lineId.tuningStep }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.duplexHigh') }} : <span class="font-bold">{{ lineId.duplexHigh }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.duplexLow') }} : <span class="font-bold">{{ lineId.duplexLow }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.transmissionPower') }} : <span class="font-bold">{{ lineId.transmissionPower }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.status') }} : <span class="font-bold">{{ $t(`entity.lineId.statusOptions.${lineId.status.toLowerCase()}`) }}</span>
            </p>
          </div>
        </div>
      </div>
    </Panel>

    <!-- Spécifications de l'équipement -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold p-0 pl-2 m-0">
          {{ $t('lineidpage.fieldset.equipment') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.spectrumService') }} : <span class="font-bold">{{ lineId.spectrumService }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.spectrumServiceOther') }} : <span class="font-bold">{{ lineId.spectrumServiceOther }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.manufacturer') }} : <span class="font-bold">{{ lineId.manufacturer }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.equipmentReference') }} : <span class="font-bold">{{ lineId.equipmentReference }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.numberOfEquipment') }} : <span class="font-bold">{{ lineId.numberOfEquipment }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.associated') }} : <span class="font-bold">{{ $t( lineId.associated ? 'action.yes' : 'action.no') }}</span>
            </p>
          </div>
        </div>
      </div>
    </Panel>

    <!-- Spécifications de l'antenne -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold p-0 pl-2 m-0">
          {{ $t('lineidpage.fieldset.antenna') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.antennaReference') }} : <span class="font-bold">{{ lineId.antennaReference }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.antennaHalfPowerAngle') }} : <span class="font-bold">{{ lineId.antennaHalfPowerAngle }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.antennaDiameter') }} : <span class="font-bold">{{ lineId.antennaDiameter }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.antennaHeightAboveGround') }} : <span class="font-bold">{{ lineId.antennaHeightAboveGround }}</span>
            </p>
          </div>
        </div>
      </div>
    </Panel>

    <!-- Spécifications Wifi -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold p-0 pl-2 m-0">
          {{ $t('lineidpage.fieldset.wifi') }}
        </p>
      </template>
      <div class="card_details">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.wirelessLanSsid') }} : <span class="font-bold">{{ lineId.wirelessLanSsid }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.wirelessLanMacAddress') }} : <span class="font-bold">{{ lineId.wirelessLanMacAddress }}</span>
            </p>
            <p class="col-12 md:col-6">
              {{ $t('entity.lineId.standardTechnology') }} : <span class="font-bold">{{ lineId.standardTechnology }}</span>
            </p>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import {LINEID_STATUS} from "@/shared/constants";
import Panel from "primevue/panel";

export default {
  name: 'LineIdDetail',
  components: {Panel},
  props: {
    lineId: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      status: LINEID_STATUS,
    }
  },
}
</script>

<style lang="scss" scoped>

.line-id-data {
  p {
    margin: 0;
    padding: 2px;
  }
}

</style>
